import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect, } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import {
    CreatePrograma, CreateProgramaSuccess, DeletePrograma, DeleteProgramaSuccess,
    GetProgramas, GetProgramasSuccess, UpdatePrograma, UpdateProgramaSuccess
} from '../actions/programas.actions';
import { IDeleteProgramaResponse, IPrograma, IUpdateProgramaResponse } from 'src/app/interfaces/programas.insterface';


@Injectable()
export class ProgramasEffects {
    getPrograma$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GetProgramas),
            switchMap(() =>
                this.apiService.getProgramas().pipe(
                    map((programas: IPrograma[]) => GetProgramasSuccess({ programas }))
                )
            )
        )
    );

    createPrograma$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CreatePrograma),
            switchMap(payload =>
                this.apiService.createProgramas(payload.programa).pipe(
                    map((programa: IPrograma) => CreateProgramaSuccess({ programa }))
                )
            )
        )
    );

    deletePrograma$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeletePrograma),
            switchMap(payload =>
                this.apiService.deleteProgramas(payload.id).pipe(
                    map((programa: IDeleteProgramaResponse) => DeleteProgramaSuccess({ programa }))
                )
            )
        )
    );

    updatePrograma$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UpdatePrograma),
            switchMap(payload =>
                this.apiService.updateProgramas(payload.id, payload.programa).pipe(
                    map((programa: IUpdateProgramaResponse) => UpdateProgramaSuccess({ programa }))
                )
            )
        )
    );

    constructor(
        private apiService: ApiService,
        private actions$: Actions,
        private store: Store<IAppState>
    ) { }
}
